import { render, staticRenderFns } from "./NewPhdThesis.vue?vue&type=template&id=b1fef84a&"
import script from "./NewPhdThesis.vue?vue&type=script&lang=js&"
export * from "./NewPhdThesis.vue?vue&type=script&lang=js&"
import style0 from "./NewPhdThesis.vue?vue&type=style&index=0&id=b1fef84a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports